import type { AlphaRun, AlphaRunsResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getAlphaRuns } from "../api/alphaRuns.api";

const POLLING_INTERVAL_MS = 2000;

const ACTIVE_STATUSES = new Set<AlphaRun["status"]>([
  "reserving",
  "queued",
  "planning",
  "rendering",
]);

export function alphaRunsKey(
  requestId: number,
): readonly ["alpha-runs", number] {
  return ["alpha-runs", requestId] as const;
}

export function isAlphaRunActive(run: AlphaRun): boolean {
  return ACTIVE_STATUSES.has(run.status);
}

export function alphaRunsPollingInterval(
  data?: AlphaRunsResponse,
): false | number {
  return data?.runs.some((run) => isAlphaRunActive(run))
    ? POLLING_INTERVAL_MS
    : false;
}

export function useAlphaRunsQuery(
  requestId: number,
): UseQueryResult<AlphaRunsResponse> {
  return useQuery({
    enabled: Boolean(requestId && !Number.isNaN(requestId)),
    queryFn: () => getAlphaRuns(requestId),
    queryKey: alphaRunsKey(requestId),
    refetchInterval: (query) => alphaRunsPollingInterval(query.state.data),
  });
}
